import { Grid, IconButton } from '@material-ui/core';
import React, { memo } from 'react';
import KeyboardArrowRightIcon from '@material-ui/icons/KeyboardArrowRight';
import style from '../NewPatient/NewPatientsTabs.module.css';
import Skeleton from '@material-ui/lab/Skeleton';

const WorkFlowTabSkeleton = ({ showArrow = false }) => {
    return (
        <Grid item style={{ textAlign: 'center', display: 'flex' }}>
            <div className={style.iconButtonContainer}>
                <div className={style.CustomBadgeContainer}>
                    <Skeleton variant="circle" width={48} height={48} />
                </div>
                <Skeleton variant="rect" width={100} height={20} />
            </div>
            {showArrow && (
                <div className={style.iconButtonArrowContainer}>
                    <IconButton aria-label="delete" disabled className="iconButtonArrow">
                        <KeyboardArrowRightIcon />
                    </IconButton>
                </div>
            )}
        </Grid>
    );
};

export default memo(WorkFlowTabSkeleton);
